
export const adjustHeight = (textarearef) => {
		const textarea = textarearef.current;

		if (textarea) {
			// Reset height to 'auto' to allow proper recalculation
			textarea.style.height = 'auto';

			const computedStyle = window.getComputedStyle(textarea);

			// Get padding, border, and font styles
			const paddingTop = parseFloat(computedStyle.paddingTop);
			const paddingBottom = parseFloat(computedStyle.paddingBottom);
			const borderTop = parseFloat(computedStyle.borderTopWidth);
			const borderBottom = parseFloat(computedStyle.borderBottomWidth);
			const border = borderTop + borderBottom;

			// Create a hidden span to measure character width accurately
			const testSpan = document.createElement("span");
			testSpan.style.visibility = "hidden";
			testSpan.style.whiteSpace = "nowrap"; // Prevent text wrapping
			testSpan.style.position = "absolute";
			testSpan.style.fontSize = computedStyle.fontSize;
			testSpan.style.fontFamily = computedStyle.fontFamily;
			testSpan.style.fontWeight = computedStyle.fontWeight;
			testSpan.style.lineHeight = computedStyle.lineHeight;

			document.body.appendChild(testSpan);

			// Measure width of one character (we use "M" since it’s usually the widest character)
			testSpan.textContent = "M";
			document.body.removeChild(testSpan); // Clean up the span

			// Calculate content width, accounting for padding and borders
			const contentWidth = textarea.clientWidth - paddingTop - paddingBottom - border;

			// Get the text content and its length
			const text = textarea.value;

			// Measure the width of the actual content inside the textarea
			const textWidth = getTextWidth(text, computedStyle);

			// If the text fits within the contentWidth, keep the height at initial height
			if (textWidth <= contentWidth) {
				textarea.style.height = `${45}px`; // Set it to the initial height for a single line
			} else {
				// Estimate the number of lines by calculating the width of the text
				const lines = Math.ceil(textWidth / contentWidth);
				const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.2;

				// Calculate the adjusted height based on the number of lines
				const adjustedHeight = lines * lineHeight + paddingTop + paddingBottom + border;

				// Explicitly reduce the bottom padding to ensure it is smaller than the top padding
				const adjustedBottomPadding = paddingTop * 0.5; // Reduce bottom padding to 50% of top padding

				// Apply the adjusted height and custom bottom padding to balance vertical alignment
				textarea.style.height = `${adjustedHeight}px`;
				textarea.style.paddingTop = `${paddingTop}px`;
				textarea.style.paddingBottom = `${adjustedBottomPadding}px`;

				// Normalize box-sizing: border-box to prevent box-sizing inconsistencies
				textarea.style.boxSizing = 'border-box';
			}

			// Align text to the left
			textarea.style.textAlign = "left"; // Ensures the text aligns to the left
		}
	};

    // Function to calculate the width of the text using the computed style of the textarea
export const getTextWidth = (text, computedStyle) => {
		const canvas = document.createElement("canvas");
		const context = canvas.getContext("2d");

		// Set the font properties to match the textarea
		context.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;

		// Measure the text width
		return context.measureText(text).width;
	};